import type { TypeB24 } from '../../../types/b24'
import type { LoggerInterface } from '../../../types/logger'
import type { AbstractAction } from '../abstract-action'
import { LoggerFactory } from '../../../logger'
import { CallV3 } from './call'
import { CallListV3 } from './call-list'
import { FetchListV3 } from './fetch-list'
import { CallTailV3 } from './call-tail'
import { FetchTailV3 } from './fetch-tail'
import { AggregateV3 } from './aggregate'
import { BatchV3 } from './batch'
import { BatchByChunkV3 } from './batch-by-chunk'

const callName = Symbol('call_V3')
const callListName = Symbol('callList_V3')
const fetchListName = Symbol('fetchList_V3')
const callTailName = Symbol('callTail_V3')
const fetchTailName = Symbol('fetchTail_V3')
const aggregateName = Symbol('aggregate_V3')
const batchName = Symbol('batch_V3')
const batchByChunkName = Symbol('batchByChunk_V3')
/**
 * Some actions for TypeB24 by Api:v3
 */
export class ActionsManagerV3 {
  protected _b24: TypeB24
  protected _logger: LoggerInterface

  protected _mapActions: Map<symbol, AbstractAction>

  constructor(b24: TypeB24) {
    this._b24 = b24
    this._logger = LoggerFactory.createNullLogger()

    this._mapActions = new Map()
  }

  public setLogger(logger: LoggerInterface): void {
    this._logger = logger
  }

  public getLogger(): LoggerInterface {
    return this._logger
  }

  get call(): CallV3 {
    if (!this._mapActions.has(callName)) {
      this._mapActions.set(callName, new CallV3(this._b24, this._logger))
    }
    return this._mapActions.get(callName)! as CallV3
  }

  get callList(): CallListV3 {
    if (!this._mapActions.has(callListName)) {
      this._mapActions.set(callListName, new CallListV3(this._b24, this._logger))
    }
    return this._mapActions.get(callListName)! as CallListV3
  }

  get fetchList(): FetchListV3 {
    if (!this._mapActions.has(fetchListName)) {
      this._mapActions.set(fetchListName, new FetchListV3(this._b24, this._logger))
    }
    return this._mapActions.get(fetchListName)! as FetchListV3
  }

  get callTail(): CallTailV3 {
    if (!this._mapActions.has(callTailName)) {
      this._mapActions.set(callTailName, new CallTailV3(this._b24, this._logger))
    }
    return this._mapActions.get(callTailName)! as CallTailV3
  }

  get fetchTail(): FetchTailV3 {
    if (!this._mapActions.has(fetchTailName)) {
      this._mapActions.set(fetchTailName, new FetchTailV3(this._b24, this._logger))
    }
    return this._mapActions.get(fetchTailName)! as FetchTailV3
  }

  get aggregate(): AggregateV3 {
    if (!this._mapActions.has(aggregateName)) {
      this._mapActions.set(aggregateName, new AggregateV3(this._b24, this._logger))
    }
    return this._mapActions.get(aggregateName)! as AggregateV3
  }

  get batch(): BatchV3 {
    if (!this._mapActions.has(batchName)) {
      this._mapActions.set(batchName, new BatchV3(this._b24, this._logger))
    }
    return this._mapActions.get(batchName)! as BatchV3
  }

  get batchByChunk(): BatchByChunkV3 {
    if (!this._mapActions.has(batchByChunkName)) {
      this._mapActions.set(batchByChunkName, new BatchByChunkV3(this._b24, this._logger))
    }
    return this._mapActions.get(batchByChunkName)! as BatchByChunkV3
  }
}
